var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4376"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1896",
    x: 11.75,
    y: 0.5,
    width: 11,
    height: 19,
    rx: 1.5,
    stroke: "#556BB8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 433",
    d: "M17 7.08929L11.1875 11.9297L11.1875 2.24882L17 7.08929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.907906 14.0716C0.95273 14.0851 1.00204 14.0895 1.04686 14.0895C1.23961 14.0895 1.42339 13.9864 1.52649 13.8116C3.63325 10.1001 5.82967 9.84911 8.33537 9.83118V12.0545C8.33537 12.2607 8.45192 12.4489 8.6357 12.5431C8.81948 12.6372 9.03912 12.6193 9.20497 12.5027L16.0542 7.58098C16.1976 7.47788 16.2828 7.31203 16.2828 7.13273C16.2828 6.95343 16.1976 6.78758 16.0542 6.68448L9.20497 1.78962C9.03912 1.66859 8.81948 1.65514 8.6357 1.74927C8.45192 1.84341 8.33985 2.03167 8.33985 2.23786V4.49703C5.19315 4.76598 2.9564 5.99418 1.69682 8.15025C0.625509 9.9791 0.5 12.1038 0.5 13.5427C0.5 13.7892 0.670334 14.0088 0.907906 14.0716ZM8.91361 5.55938C9.20497 5.54593 9.43358 5.30388 9.43358 5.01252V3.30918L14.7901 7.1417L9.43358 10.9877V9.28432C9.43358 9.14088 9.37531 8.99744 9.27221 8.89434C9.16911 8.79125 9.03016 8.73297 8.88223 8.73297C6.47066 8.73297 3.99185 8.73297 1.71475 11.5614C2.10921 8.72849 3.62429 5.82385 8.91361 5.55938Z",
    fill: "#556BB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.dba26ecd21b07e92c45dc137ad028d8a.svg";
export { ForwardRef as ReactComponent };